<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberTanimlama"> Haber Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberListDetay"> Haber Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberKisaList"> Haber Kısa Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberCount"> Haber count
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberDetay"> Haber Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberDurumGuncelle"> Haber Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberGuncelle"> Haber Guncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import haberService from '../../../WSProvider/HaberService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataKader = "";
    export default {
        name: "HaberDetay",
        methods: {
            haberTanimlama() {
                haberService.haberTanimlama("testgfdhaber", 1, "Test Haber", "", "deneme içerik", "Seo Baslik", "seo Içerik haber", ["resim", "resim2"], ["efhsdf","fekghjfsdlg"],"lkjglk","jhgkljgljk","llkjhjlh", 1, 1, 1, "2020-06-09", "2020-06-25", 1,1,1,[]);
            },
            haberKisaList() {
                haberService.haberKisaList("HK-1000", 20);
            },
            haberDurumGuncelle() {
                haberService.haberDurumGuncelle("HB-1000", 0);
            },
            haberListDetay() {
                haberService.haberListDetay("HK-1000", 0, 10, 1);
            },
            haberCount() {
                haberService.haberCount(1);
            },
            haberDetay() {
                haberService.haberDetay("HB-1000");
            },
            haberGuncelle() {
                let updateList = [{
                    type: "videoList",
                    value: [
                        {
                            durum : 2,
                            url : "dfdsdsf"
                        },
                        {
                            durum : 0,
                            url : "fdshfsdf"
                        }
                    ]
                }];
                haberService.haberGuncelle("HB-1000", updateList);
            },

        }
    }
</script>

<style scoped>

</style>